var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.6 511.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434A54"
    },
    points: "366.46,434.738 131.987,251.584 145.109,234.785 379.607,417.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434A54"
    },
    points: "383.603,427.651 362.464,425.012 405.087,83.943 426.257,86.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434A54"
    },
    points: "143.829,252.444 133.276,233.927 410.395,76.003 420.949,94.528  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M266.452,255.8c0,70.632-57.26,127.9-127.9,127.9s-127.9-57.269-127.9-127.9 c0-70.64,57.26-127.9,127.9-127.9S266.452,185.16,266.452,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M500.949,85.27c0,47.088-38.188,85.261-85.277,85.261s-85.277-38.173-85.277-85.261 c0-47.097,38.188-85.27,85.277-85.27S500.949,38.173,500.949,85.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC87C0"
    },
    d: "M458.294,426.339c0,47.088-38.157,85.261-85.246,85.261c-47.119,0-85.276-38.173-85.276-85.261 c0-47.104,38.157-85.277,85.276-85.277C420.138,341.062,458.294,379.235,458.294,426.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48CFAD"
    },
    d: "M233.298,341.717v-6.026c0-9.758-6.276-18.423-15.613-21.515l-0.703-0.203 c-10.258-2.747-13.731-5.401-18.298-7.135c-16.19-6.167-20.406-10.616-21.483-12.709c-0.039-0.078-0.07-0.156-0.101-0.234 l-0.141-18.812l-38.408-0.438l-38.415,0.438l-0.133,18.812c-0.031,0.078-0.062,0.156-0.102,0.234 c-1.077,2.093-5.292,6.542-21.491,12.709c-4.559,1.733-8.033,4.388-18.291,7.135l-0.703,0.203 c-9.336,3.092-15.613,11.757-15.613,21.515v6.026c23.396,25.793,57.182,41.983,94.746,41.983S209.902,367.51,233.298,341.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M191.854,238.673c0,34.629-33.021,66.495-53.302,66.495S85.25,273.302,85.25,238.673 s23.864-57.479,53.302-57.479S191.854,204.044,191.854,238.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EB"
    },
    d: "M479.06,142.287v-5.613c0-6.533-4.215-12.326-10.461-14.395l-0.468-0.133 c-6.839-1.843-9.181-3.614-12.24-4.777c-10.835-4.13-13.646-7.104-14.364-8.509c-0.031-0.047-0.031-0.102-0.062-0.156l-0.094-12.584 l-25.698-0.289l-25.698,0.289l-0.094,12.584c-0.031,0.055-0.031,0.109-0.062,0.156c-0.719,1.405-3.561,4.379-14.396,8.509 c-3.028,1.163-5.37,2.935-12.209,4.777l-0.499,0.133c-6.246,2.068-10.43,7.861-10.43,14.395v5.613 c15.612,17.338,38.22,28.243,63.388,28.243S463.447,159.625,479.06,142.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M451.331,81.093c0,23.169-22.076,44.488-35.659,44.488s-35.659-21.319-35.659-44.488 c0-23.17,15.955-38.462,35.659-38.462C435.375,42.631,451.331,57.923,451.331,81.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M436.436,483.357v-5.605c0-6.541-4.215-12.334-10.461-14.41l-0.468-0.125 c-6.87-1.842-9.181-3.622-12.24-4.777c-10.835-4.138-13.646-7.104-14.364-8.509c-0.031-0.047-0.062-0.109-0.094-0.156l-0.062-12.584 l-25.698-0.297l-25.698,0.297l-0.094,12.584c-0.031,0.047-0.062,0.109-0.062,0.156c-0.75,1.405-3.561,4.371-14.395,8.509 c-3.061,1.155-5.371,2.936-12.241,4.777l-0.468,0.125c-6.246,2.076-10.43,7.869-10.43,14.41v5.605 c15.582,17.346,38.22,28.243,63.388,28.243S420.824,500.702,436.436,483.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M408.708,422.154c0,23.169-22.107,44.496-35.659,44.496c-13.583,0-35.659-21.327-35.659-44.496 c0-23.17,15.956-38.454,35.659-38.454C392.721,383.7,408.708,398.985,408.708,422.154z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNetwork);
export default __webpack_public_path__ + "static/media/social_network.cdacdbcf0710b7ad42761240b18edf6b.svg";
export { ForwardRef as ReactComponent };